module.exports = __webpack_public_path__ + "img/payment_mb_01.aa1a8c92.png";